<template>
	<div class="insurance-plan">
		<ul>
			<li v-for="coverage in topLevelCoverages" :key="coverage.id">
				<PlanCoverage v-bind="coverage" />
			</li>
			<li v-if="coverage_description">
				<div class="coverage-percent">Reimbursement <span>{{ coverage_percent * 100}}%</span></div>
				<div class="coverage-description" v-html="coverage_description" />
			</li>
		</ul>
		<div class="addons-title" v-if="checkForAddons">Addons</div>
		<ul class="add-ons-list">
			<li class="add-ons-list-item"
				v-for="addon in addons" :key="addon.index">
				<div class="priced-item-wrapper">
					<div class="checkbox">
						<input
							class="hidden-input"
							checked="checked"
							disabled="disabled"
							type="checkbox"
							:value="addon"
							:id="addon.title"
						/>
						<span class="checkmark"></span>
					</div>
					<PricedItem :title="addon.title" :amount="addon.cost" />
				</div>
				<div class="add-on-description" v-html="addon.description" />
			</li>
		</ul>
		<AnimatedNumber class="premium-amount" :number="premium" :filters="'currency'" />
		<div class="premium-title">Monthly Premium</div>
		<div class="premium-description" v-html="premium_description" />
	</div>
</template>

<script>
import AnimatedNumber from "@/components/base/AnimatedNumber";
import PlanCoverage from "@/components/game/shop/plan/PlanCoverage";
import PricedItem from "@/components/base/PricedItem";

export default {
	name: "PurchasedPlans",
	components: {
		AnimatedNumber,
		PlanCoverage,
		PricedItem,
	},
	props: {
		addons: {
			type: Array,
			required: true,
		},
		coverages: {
			type: Object,
			required: true,
		},
		type: {
			type: Number,
			required: true,
		},
		coverage_percent: {
			type: Number,
			required: true,
		},
		coverage_description: {
			type: String,
			required: false,
		},
		premium_description: {
			type: String,
			required: true,
		},
	},
	computed: {
		topLevelCoverages() {
			return Object.values(this.coverages).filter((coverage) => !coverage.isSublimt) || {};
		},
		premium() {
			return this.$store.getters[`game/plans/${this.type}/totalCost`];
		},
		checkForAddons() {
			return this.addons.length > 0;
		},
	},
};
</script>

<style lang="scss" scoped>
	.insurance-plan {
		margin: auto;
		width: 80%;
	}

	.coverage-percent { color: white; }

	.addons-title {
		font-family: $heading-font;
		letter-spacing: $letter-spacing-plus;
		text-transform: uppercase;
	}

	.add-ons-list {
		margin-bottom: 20px;
	}

	.priced-item-wrapper {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.checkbox { margin-right: 10px; }

	.checkbox,
	.hidden-input{
		display: block;
		position: relative;
		height: $checkbox-width;
		width: $checkbox-width;

		@include mobile {
			height: $checkbox-width-mobile;
			width: $checkbox-width-mobile;
		}
	}

	.hidden-input:checked ~ .checkmark {
		background: linear-gradient(90deg, $primary-color-light 0%, $primary-color-extra-light 100%);
		border-color: white;

		&:after { display: block; }
	}

	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: $checkbox-width;
		width: $checkbox-width;
		pointer-events: none;
		border: solid $border-width-sm $alt-color-extra-light;

		@include mobile {
			height: $checkbox-width-mobile;
			width: $checkbox-width-mobile;
		}

		&:after {
			content: '';
			display: none;
			position: absolute;
			left: 50%;
			right: 0;
			bottom: 15%;
			margin: auto;
			width: 10px;
			height: 30px;
			border: solid white;
			border-top: $border-width-sm;
			border-left: $border-width-sm;
			transform: rotate(45deg);

			@include mobile { height: 20px; }
		}
	}

	.priced-item { text-transform: uppercase; }

	.add-on-description {
		font-size: $font-size-sm;
		padding-left: $checkbox-width;
		margin-left: 10px;
		color: $gray-light;
	}

	.premium-amount {
		font-family: $heading-font;
		font-size: $heading-size-md;
		color: $primary-color-extra-light;
	}

	.premium-title { color: white; }

	.plan-summary {
		color: $gray-light;
		font-size: $font-size-sm;
	}

	.coverage-description,
	.premium-description {
		font-size: $font-size-sm;
		color: $gray-light;
	}
</style>
